import React from "react";
import { Box, Typography } from "@mui/material";

const Legend = ({ closingCount = 0, newCount = 0 }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
        width: "100%",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Box
          sx={{
            width: 20,
            height: 20,
            backgroundColor: "rgba(76, 175, 80, 0.1)",
            border: "1px solid rgba(76, 175, 80, 0.2)",
          }}
        />
        <Typography variant="body2">NEW POSITION ({newCount})</Typography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Box
          sx={{
            width: 20,
            height: 20,
            backgroundColor: "rgba(244, 67, 54, 0.1)",
            border: "1px solid rgba(244, 67, 54, 0.2)",
          }}
        />
        <Typography variant="body2">
          CLOSING POSITION ({closingCount})
        </Typography>
      </Box>
    </Box>
  );
};

export default Legend;